import { useContext } from "react";
import { useDispatch } from "react-redux";
import { FileSpreadsheet, FileText } from "lucide-react";
import { downloadCompanyList } from "../../../actionCreator/companyListingActionCreater";
import { saveExcel, savePDF } from "../../../utils";
import { useAlert } from "../../../context/AlertProvider";
import { AuthContext } from "../../../context/AuthContext";

const columns = [
  { header: "Serial No.", key: "serealNo" },
  { header: "Company Name", key: "name" },
  { header: "Phone", key: "phoneNo" },
  { header: "Address", key: "address" },
  { header: "City", key: "city" },
  { header: "State", key: "state" },
  { header: "Country", key: "country" },
  { header: "Pin", key: "pincode" },
  { header: "Website", key: "wedsite" },
  { header: "Company Revenue", key: "revenueName" },
  { header: "Employee Range", key: "employeeRange" },
  { header: "Industry", key: "industryName" },
];

export const useExport = () => {
  const dispatch = useDispatch();
  const { isAuthenticated: isLoggedIn } = useContext(AuthContext);
  const { showAlert } = useAlert();

  const onExport = async (selectedRecords, type) => {
    if (isLoggedIn) {
      if (selectedRecords.length) {
        const res = await dispatch(downloadCompanyList(selectedRecords, type));
        if (res?.response?.status === 403) {
          showAlert(
            "warning",
            "Permission Denied",
            "You do not have permission to download companies data.",
          );
        }
        if (res?.length) {
          const downloadedUpdatedData = getSchema(res);
          const fileName = "Company Data";
          if (type === "exl") {
            saveExcel(downloadedUpdatedData, columns, fileName);
          } else {
            savePDF(downloadedUpdatedData, columns, fileName);
          }
          showAlert(
            "success",
            "Download Complete",
            <div>
              Your Company Data has been successfully downloaded to{" "}
              {type === "exl" ? (
                <FileSpreadsheet size={16} className="tw-text-[#4CAF50] tw-inline tw-ml-1" />
              ) : (
                <FileText size={16} className="tw-text-[#f44336] tw-inline tw-ml-1" />
              )}
              .
            </div>,
          );
        }
      } else {
        showAlert("warning", "please select record.");
      }
    }
  };

  const getSchema = (data) => {
    var finaldata = [];
    let cnt = 0;
    data.forEach((obj) => {
      cnt++;
      var dataObj = {};
      dataObj.id = obj.id;
      dataObj.serealNo = cnt;
      dataObj.name = obj.name;
      dataObj.revenueName = obj?.revenue?.name;
      dataObj.employeeRange = obj?.range?.name;
      dataObj.industryName = obj?.industry?.name;
      dataObj.country = obj.country;
      dataObj.state = obj.state;
      dataObj.city = obj.city;
      dataObj.wedsite = obj.wedsite;
      dataObj.address = obj.address;
      dataObj.pincode = obj.pincode;
      dataObj.phoneNo = obj.phoneNo;
      finaldata.push(dataObj);
    });
    return finaldata;
  };

  return { onExport };
};
